import { filterEntitiesByField } from './__shared._._utils'
import { type IChatMember } from './chat-member._._definitions'
import { mapChatMembersFields } from './chat-member._._utils'
import {
	CHAT_TYPE,
	type IChat,
	type IChatStatus,
	type IChatType,
} from './chat._._definitions'

export const mapChatsFields = (chats: IChat[]): IChat[] =>
	chats.map(mapChatFields)

export const mapChatFields = (chat: IChat): IChat => ({
	...chat,
	...(chat.status && { status: chat.status as IChatStatus }),
	...(chat.type && { type: chat.type as IChatType }),
	...(chat.members && {
		members: mapChatMembersFields(chat.members).filter(Boolean),
	}),
})

export const updateChatMembersAiName = (
	chat: IChat,
	name: string,
): IChatMember[] => {
	return (
		chat.members?.map((member) => {
			if (member.memberIsAi) {
				return { ...member, user: { ...member.user, name } } as IChatMember
			}
			return member
		}) ?? []
	)
}

export const filterChatsByStatus = (chats: IChat[], status: IChatStatus) => {
	return filterEntitiesByField(chats, 'status', status)
}

export const filterChatsByType = (chats: IChat[], type: IChatType) => {
	return filterEntitiesByField(chats, 'type', type)
}

export const partitionChatsByType = (chats: IChat[]) => {
	return {
		aiChats: filterChatsByType(chats, CHAT_TYPE.AI),
		groupChats: filterChatsByType(chats, CHAT_TYPE.GROUP),
	}
}
